import { ready } from '../../lib/lifecycle/ready';
import { initFancybox, destroyFancybox } from '../../lib/lightbox/fancyboxInit';

const selector = '.wp-block-modulr-image a.modulr-image-lightbox-link[data-fancybox]';

function initImageLightbox(root) {
  const scope = root || document;
  if (scope.querySelectorAll(selector).length === 0) return undefined;
  initFancybox(selector);

  return function destroy() {
    destroyFancybox(selector);
  };
}

ready(initImageLightbox, { scope: 'modulr-image-lightbox' });
